const initialState = {
	getProfile: null,
    isSmSignInReady: false,
    getSmUser: null,
    submitRegister: false,
    isChromeExtInstalled: false,
    googleUserId: null,
    isAnsweredChromeExtInstallRequest: false,
    isAdminUser: false,
    showIntegrateGoogleButton: false,
    setGmailAddOnData:{},
    checkActiveGmailAddOnLabel:"",
    checkGmailAddOnFromMarketPlace:"",
	sharingPageReady: false,
	isEditModeProfile: false,
	isLoadingProfileChange: false,
	profileAvatarToUpload: ""
};

const profileReducer = ( state = initialState, action ) => {
	switch (action.type){

        case "SET_GMAIL_ADD_ON_FROM_MARKET_PLACE":
            state = {
              ...state,
              checkGmailAddOnFromMarketPlace: action.payload
               };
               break;

        case "GET_PROFILE":
			let profileData = action.payload || {};
			state = {
				...state,
				getProfile: {
					...profileData,
					accessStatus: profileData.accessStatus || {}
				}
			};
			break;
        case "IS_SM_SIGNIN_READY":
            state = {
                ...state,
                isSmSignInReady: action.payload
            };
            break;
        case "GET_SM_USER":
            state = {
                ...state,
                getSmUser: action.payload
            };
            break;

        case 'GMAIL_ADD_ON_DATA':
            state = {
                  ...state,
                  setGmailAddOnData: action.payload,
                };
                break;

        case 'CHECK_ACTIVE_GMAIL_ADD_ON_LABEL':
            state = {
                  ...state,
                  checkActiveGmailAddOnLabel: action.payload,
                  };
                  break;

        case "SUBMIT_REGISTER":
            state = {
                ...state,
                submitRegister: action.payload
            };
            break;
        case "IS_CHROME_EXT_INSTALLED":
            state = {
                ...state,
                isChromeExtInstalled: action.payload
            };
            break;
        case "GOOGLE_USER_ID":
            state = {
                ...state,
                googleUserId: action.payload
            };
            break;
        case "IS_ANSWERED_CHROME_EXT_INSTALL_REQUEST":
            state = {
                ...state,
                isAnsweredChromeExtInstallRequest: action.payload
            };
            break;
        case "IS_ADMIN_USER":
            state = {
                ...state,
                isAdminUser: action.payload
            };
            break;
        case "SHOW_INTEGRATE_GOOGLE_BUTTON":
            state = {
                ...state,
                showIntegrateGoogleButton: action.payload
            };
            break;
        case "SHARING_PAGE_READY":
	        state = {
		        ...state,
		        sharingPageReady: action.payload
	        };
	        break;
		case "IS_EDIT_MODE_PROFILE":
			state = {
				...state,
				isEditModeProfile: action.payload
			};
			break;
		case "IS_LOADING_PROFILE_CHANGE":
			state = {
				...state,
				isLoadingProfileChange: action.payload
			};
			break;
		case "PROFILE_AVATAR_TO_UPLOAD":
			state = {
				...state,
				profileAvatarToUpload: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default profileReducer;
